import ReactDOM from "react-dom/client"
import App from "./App"
import "./styles.css"

const root = ReactDOM.createRoot(document.querySelector("#root"))

root.render(<App />)
